export function getButtonAppearance(type) {
  if (type === "primary") {
    return "primary";
  }
  if (type === "secondary") {
    return "secondary";
  }
  if (type === "alternative") {
    return "alternative";
  }

  if (type === "disabled") {
    return "disabled";
  }

  // Shouldn't happen, but default to dark button just in case
  return "primary";
}
